import { render, staticRenderFns } from "./Dvantage.vue?vue&type=template&id=0aab18b8&scoped=true"
import script from "./Dvantage.vue?vue&type=script&lang=js"
export * from "./Dvantage.vue?vue&type=script&lang=js"
import style0 from "./Dvantage.vue?vue&type=style&index=0&id=0aab18b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab18b8",
  null
  
)

export default component.exports